import OrzioMark from "./OrzioMark";
import type { OrzioMarkSize } from "./OrzioMark";

type OrzioLogoVariant = "horizontal" | "stacked" | "compact" | "lightBg" | "darkBg";

interface OrzioLogoProps {
  variant?: OrzioLogoVariant;
  size?: "sm" | "md" | "lg";
  className?: string;
  animated?: boolean;
}

const MARK_SIZE: Record<NonNullable<OrzioLogoProps["size"]>, OrzioMarkSize> = {
  sm: "sm",
  md: "md",
  lg: "lg",
};

export default function OrzioLogo({
  variant = "horizontal",
  size = "md",
  className = "",
  animated = true,
}: OrzioLogoProps) {
  const isStacked = variant === "stacked";
  const isCompact = variant === "compact";
  const isDark = variant === "darkBg";

  if (isCompact) {
    return <OrzioMark size={MARK_SIZE[size]} animated={animated} variant={isDark ? "dark" : "light"} className={className} />;
  }

  return (
    <span
      className={[
        "orzio-logo",
        isStacked ? "orzio-logo--stacked" : "orzio-logo--horizontal",
        isDark ? "orzio-logo--dark" : "orzio-logo--light",
        className,
      ].join(" ")}
    >
      <OrzioMark size={MARK_SIZE[size]} animated={animated} variant={isDark ? "dark" : "light"} />
      <span className="orzio-logo__text">Orzio</span>
    </span>
  );
}
